import React from 'react';
import { Tabs, Typography } from 'antd';
import ContractorAccountsPanel from '../components/ContractorsHub/ContractorAccountsPanel';
import CatalogsPanel from '../components/ContractorsHub/CatalogsPanel';
import PipesPanel from '../components/ContractorsHub/PipesPanel';

const { Title, Text } = Typography;

// Tenant-admin surface for Contractors Hub (EXPERIENCE.md IA: Contractor
// Accounts, Catalogs, Publish Activity -- publish history is shown inline
// per-account rather than a duplicated top-level tab for this vertical slice).
const ContractorsHub = () => (
  <div style={{ padding: 24 }}>
    <Title level={3} style={{ marginBottom: 4 }}>
      Contractors Hub
    </Title>
    <Text type="secondary">
      Publish ERP pricing to contractor ServiceTitan accounts and manage catalogs.
    </Text>
    <Tabs
      style={{ marginTop: 16 }}
      items={[
        { key: 'accounts', label: 'Contractor Accounts', children: <ContractorAccountsPanel /> },
        { key: 'catalogs', label: 'Catalogs', children: <CatalogsPanel /> },
        { key: 'pipes', label: 'Data Pipes', children: <PipesPanel /> },
      ]}
    />
  </div>
);

export default ContractorsHub;
